var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('textarea',{ref:"txtArea",staticClass:"form-control",attrs:{"rows":_vm.rows,"placeholder":_vm.placeholder,"name":_vm.name},domProps:{"value":_vm.value},on:{"change":_vm.updateContent}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3abe3557","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/autosize-textarea.vue
// module id = 1294
// module chunks = 4